<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'
    import Popover from '../../_common/popover.svelte'
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import Accounts from './accounts.svelte'
    import { Account } from '../../../modules/financialApi/accounts/account'

    export let account: Account = null
    export let disabled: boolean = false
    export let small = false
    export let label = ''
    export let bank: string = null
    export let all: boolean = false

    let query = ''
    let accounts: Account[] = []

    let delay = null
    async function search(query) {
        if (delay) clearInterval(delay)
        delay = setTimeout(async () => {
            accounts = await window.api.financials.accounts.getAll({ query, pageSize: 100, bank })
            if (accounts.length === 0) dropHelper = 'Não encontrado.'
        }, 500)
    }
    async function getFirst100() {
        accounts = await window.api.financials.accounts.getAll({ pageSize: 100, bank })
    }

    function select(index) {
        account = accounts[index]
        query = ''
        accounts = []
        dispatch('change', account)
    }

    async function loadService(accountId) {
        if (accountId) {
            account = await window.api.financials.accounts.getOne(accountId)
            _showDrop = false
        }
    }

    function friendlyName(p) {
        return p?.label || ''
    }

    function clear() {
        account = null
        dispatch('change', null)
        _showDrop = false
    }

    let showForm = false
    function newService() {
        account = new Account()
        showForm = true
    }

    function editService() {
        showForm = true
    }

    async function hideForm(event) {
        showForm = false
        await getFirst100()
        if (event.detail?.accountId) {
            account = event.detail
            dispatch('change', account)
        } else {
            if (account?.accountId) {
                account = accounts.find((el) => el.accountId === account.accountId)
                dispatch('change', account)
            }
        }
    }

    let _showDrop = false
    let dropHelper = 'Digite ao menos 3 caracteres para pesquisar...'
    function showDrop(event) {
        _showDrop = true
    }

    function hideDrop(event) {
        setTimeout(() => {
            _showDrop = false
        }, 300)
    }

    onMount(async () => {
        await getFirst100()
    })

    $: {
        if (account?.accountId && !account?.createdAt) loadService(account.accountId)
        search(query)
    }
</script>

{#if showForm}
    <Popover on:close={hideForm} title="Conta" height="420px" width="970px">
        <Accounts accountId={account.accountId} form={true} {bank} on:close={hideForm} />
    </Popover>
{/if}
<div class="query">
    <div class="input-group custom-control" class:input-group-sm={small === true}>
        {#if label}
            <div class="input-group-text">{label}</div>
        {/if}
        {#if account && account.accountId}
            <input
                class="form-control"
                class:form-control-sm={small === true}
                disabled
                value={friendlyName(account)}
                type="text"
            />
            <!-- <button on:click={editService} class="btn btn-secondary"><Fa icon={faEdit} /></button> -->
            {#if !disabled}
                <button class="btn btn-secondary" class:form-control-sm={small === true} on:click={clear}
                    ><Fa icon={faTimes} /></button
                >
            {/if}
        {:else}
            <input
                class="form-control btn-end select-icon"
                class:form-control-sm={small === true}
                type="text"
                bind:value={query}
                on:focus={showDrop}
                on:blur={hideDrop}
                placeholder={all ? 'Todas' : ''}
            />
            <button on:click={newService} class="btn btn-secondary"><Fa icon={faPlus} /></button>
        {/if}
    </div>

    {#if _showDrop}
        <div class="list scroll-dark">
            {#if accounts.length === 0}
                <div class="list-helper p-2 text-muted">{dropHelper}</div>
            {:else}
                {#each accounts as p, index}
                    <button
                        on:click={() => {
                            select(index)
                        }}>{friendlyName(p)}</button
                    >
                {/each}
            {/if}
        </div>
    {/if}
</div>

<style>
    .list-helper {
        color: #333;
        background-color: #eee;
    }
    .query {
        position: relative;
        flex-grow: 1;
        width: 100%;
    }
    .list {
        display: flex;
        flex-direction: column;
        box-shadow: 4px 3px 6px #111;
        position: absolute;
        flex-grow: 1;
        z-index: 5;
        width: 100%;
        overflow-y: auto;
        max-height: 200px;
    }
    .list button {
        flex-grow: 1;
        padding: 8px;
        text-align: left;
    }
    .list button:hover {
        background-color: #ddd;
    }
</style>
